const images = {
  opportunitycolored: require("./opportunity-colored.png").default,
  trash: require("./trash.png").default,
  coloredtrash: require("./coloredtrash.png").default,
  print: require("./printimg.png").default,
  save: require("./saveimg.png").default,
  logo: require("./logo.svg").default,
  logowhite: require("./logowhite.svg").default,
  banner: require("./banner.png").default,
  error: require("./error-image.png").default,
};

export default images;
